exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".beauti-contextmenu-item{list-style:none;margin:0}.beauti-contextmenu-item span{display:inline-block}.beauti-contextmenu-item span.icon{width:25px}.beauti-contextmenu-item.divider{height:1px;display:-webkit-box;display:-ms-flexbox;display:flex;line-height:1px;overflow:hidden}.beauti-contextmenu-item.divider:after{content:\"\";-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:inline-block;width:100%;height:1px;background-color:#f2f2f2}.beauti-contextmenu-item.disabled{color:#cbcbcb;cursor:default}.beauti-contextmenu-item:hover:not(.divider):not(.disabled){background-color:#f2f2f2}", ""]);

// exports
